<template>
  <section class="w-full">
    <label class="text-xl font-medium pb-16px" v-if="label" v-text="label"/>
    <section
      class="bg-skin-check_inactive w-full rounded-xl p-12px text-base flex justify-between items-center"
      @click="onClickShowList"
    >
      <p
        class="h-6 text-skin-check-box"
        :class="{ 'text-opacity-80': !value }"
        v-text="value ? value[itemDescriptionField] : placeholder"
      />
      <icon
        :name="'chevron'"
        :width="16"
        :height="16"
        :color="'black'"
        class="transform"
        :class="{ 'rotate-90': !showList, '-rotate-90': showList }"
      />
    </section>
    <p v-if="isThereError" class="text-xs pr-2 pt-2 text-red-500 text-left" v-text="errorMessage"/>
    <section class="relative w-full text-skin-check-box">
      <section
        v-if="showList"
        class="absolute w-full min-h-16 max-h-24 overflow-y-scroll light-scroll py-3.5 flex flex-col text-left z-30 bg-white rounded-2.5 shadow-card"
      >
        <button
          @click="onChangeSelectedItem(item)"
          class="w-full text-left px-3.5 py-1 hover:bg-skin-check_inactive"
          v-for="(item, index) in items"
          :key="index"
          v-text="item[itemDescriptionField]"
        />
      </section>
    </section>
  </section>
</template>
<script>
export default {
  mounted() {
    window.addEventListener("click", (e) => {
      if (!this.$el.contains(e.target)) {
        this.showList = false;
      }
    });
  },
  components: {
    Icon: () => import("./Icon.vue"),
  },
  data: () => ({
    showList: false,
    selectedItem: null,
    error: false,
  }),
  methods: {
    onClickShowList() {
      this.showList = !this.showList;
    },
    onChangeSelectedItem(_item) {
      this.selectedItem = _item;
      this.showList = false;
      this.$emit("input", _item)
    },
    validate() {
      if (this.value === null) {
        this.error = true;
        return true;
      }
      return false;
    },
  },
  props: {
    itemIdField: {
      required: true,
    },
    itemDescriptionField: {
      required: true,
    },
    items: {
      default: null,
    },
    value: {
      default: null,
    },
    placeholder: {
      default: "",
    },
    identity: {
      default: null,
    },
    label:{
      default: null
    }
  },
  computed: {
    errorMessage() {
      if (this.value === null) return `El campo ${this.identity} es requerido`;
      return "";
    },
    isThereError() {
      if (this.error) return this.value === null;
      return false;
    },
  },
};
</script>
